import React from "react";
import { Link } from "react-router-dom";
import Card from "../Card";
import PercentageBard from "../PercentageBar";
import DropdownOptions from "../DropdownOptions";
import i18n from "i18n";
import styles from "./MainApp.organisms.Dashboard.MostSelledCard.module.scss";

const options = [
  {
    key: "name",
    value: i18n.t("see.by.name"),
  },
  {
    key: "sku",
    value: i18n.t("see.by.sku"),
  },
];

const MostSelledCard = ({ items, handleChangeFilter, handleSeeAll }) => {
  return (
    <div className={styles["delivered-orders-card-container"]}>
      <Card>
        <div className={styles["title-container"]}>
          <h1 className={styles["dashboard-card-title"]}>{i18n.t("top.5.best.sellers.30.days")}</h1>
          <DropdownOptions
            options={options}
            selectedOption={"name"}
            handleChange={handleChangeFilter}
          />
        </div>

        <div className={styles["most-selled-table"]}>
          {items.map((item, i) => {
            return (
              <div key={i} className={styles["most-selled-item"]}>
                <div
                  className={
                    i === 0
                      ? styles["most-selled-item-left-first"]
                      : styles["most-selled-item-left"]
                  }
                >
                  <div
                    className={
                      i === 0
                        ? styles["most-selled-item-name-first"]
                        : styles["most-selled-item-name"]
                    }
                  >
                    <span className={styles["most-selled-item-position"]}>
                      {i + 1} -
                    </span>

                    {item.product}
                  </div>
                  <div className={styles["most-selled-item-bar"]}>
                    <PercentageBard
                      percentage={item.selledPercentage}
                      color={i !== 0 ? "#3C7AF5" : "#62D862"}
                    />
                  </div>
                </div>
                <div className={styles["most-selled-item-right"]}>
                  <div
                    className={
                      i === 0
                        ? styles["most-selled-item-number-first"]
                        : styles["most-selled-item-number"]
                    }
                  >
                    {item.selled}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles["most-selled-footer"]}>
          <Link to={"/admin/products"}>
            <p>{i18n.t("view.all").toUpperCase()}</p>
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default MostSelledCard;
